export default [
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () => import('../views/renaissance/policy/PrivacyPolicyView.vue')
    },
    {
        path: '/terms-of-use',
        name: 'terms-of-use',
        component: () => import('../views/renaissance/policy/TermsOfUseView.vue')
    },
    {
        path: '/user-deletion-policy',
        name: 'user-deletion-policy',
        component: () => import('../views/renaissance/policy/UserDeletionView.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/renaissance/authentication/LoginView.vue')
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/renaissance/authentication/LogoutView.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/renaissance/authentication/RegisterView.vue')
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('../views/renaissance/authentication/ForgotPasswordView.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/renaissance/dashboard/DashboardView.vue')
    },
    {
        path: '/dashboard/profile',
        name: 'dashboard-profile',
        component: () => import('../views/renaissance/dashboard/ProfileView.vue')
    },
    {
        path: '/dashboard/mailbox',
        name: 'dashboard-mailbox',
        component: () => import('../views/renaissance/dashboard/MailboxView.vue')
    },
    {
        path: '/dashboard/achievements',
        name: 'dashboard-achievements',
        component: () => import('../views/renaissance/dashboard/AchievementsView.vue')
    },
    {
        path: '/dashboard/leaderboard',
        name: 'dashboard-leaderboard',
        component: () => import('../views/renaissance/dashboard/LeaderboardView.vue')
    },
    {
        path: '/dashboard/events',
        name: 'dashboard-events',
        component: () => import('../views/renaissance/dashboard/events/EventsView.vue')
    },
    {
        path: '/dashboard/events/:id',
        name: 'dashboard-event-detail',
        component: () => import('../views/renaissance/dashboard/events/EventDetailView.vue')
    },
    {
        path: '/dashboard/quests',
        name: 'dashboard-quests',
        component: () => import('../views/renaissance/dashboard/QuestsView.vue')
    },
    {
        path: '/dashboard/banners',
        name: 'dashboard-banners',
        component: () => import('../views/renaissance/dashboard/shops/BannersView.vue')
    },
    {
        path: '/dashboard/items',
        name: 'dashboard-items',
        component: () => import('../views/renaissance/dashboard/shops/ItemsView.vue')
    },
    {
        path: '/dashboard/tutorials',
        name: 'dashboard-tutorials',
        component: () => import('../views/renaissance/dashboard/helps/TutorialsView.vue')
    },
    {
        path: '/dashboard/worldmap',
        name: 'dashboard-worldmap',
        component: () => import('../views/renaissance/dashboard/WorldMapView2.vue')
    },
    {
        path: '/worldmap',
        name: 'worldmap',
        component: () => import('../views/renaissance/worldmap/WorldMapView.vue')
    },
    {
        path: '/leaderboard',
        name: 'leaderboard',
        component: () => import('../views/renaissance/leaderboards/LeaderboardView2.vue')
    },
    {
        path: '/player',
        name: 'player',
        component: () => import('../views/renaissance/leaderboards/PlayerView.vue')
    },
    {
        path: '/mon-community',
        name: 'mon-community',
        component: () => import('../views/renaissance/worldmap/MonCommunityView.vue')
    },
    {
        path: '/ministry/ancestral-hall',
        name: 'ministry-ancestral-hall',
        component: () => import('../views/renaissance/ministry/HallOfAncestorsView.vue')
    },
        {
        path: '/ministry/endangered-dialects',
        name: 'ministry-endangered-dialects',
        component: () => import('../views/renaissance/ministry/EndangeredDialectsView.vue')
    }
];